import React from 'react';
import TabBar from './tab_bar';

import { useOrg } from '../stores/user_store';

const TABS: any[] = [
  {
    value: 'files',
    text: 'Files',
  },
  {
    value: 'settings',
    text: 'Settings',
  },
  {
    value: 'metrics',
    text: 'Metrics',
  },
  {
    value: 'audit',
    text: 'Audit Log',
  },
];
export default function VolumeTabBar(props) {
  const { style, volumeId, path } = props;
  const org = useOrg();
  let content: any = null;
  if (org?.is_admin && path === '/') {
    TABS[0].url = `/volume/${volumeId}${path}`;
    TABS[1].url = `/setting/${volumeId}${path}`;
    TABS[2].url = `/metric/${volumeId}${path}`;
    TABS[3].url = `/audit/${volumeId}${path}`;
    content = <TabBar style={style} list={TABS} />;
  }
  return content;
}
